export const viewportDimensions = () => {
  const height = window.innerHeight || "",
    width = window.innerWidth || "";
  return typeof width === "number" && typeof height === "number"
    ? width + ":" + height
    : null;
};
